import { render, staticRenderFns } from "./StackingView.vue?vue&type=template&id=26fe7008&scoped=true&"
import script from "./StackingView.vue?vue&type=script&lang=ts&"
export * from "./StackingView.vue?vue&type=script&lang=ts&"
import style0 from "./StackingView.vue?vue&type=style&index=0&id=26fe7008&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fe7008",
  null
  
)

export default component.exports